import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Non-blocking load-error notice with retry. Extracted verbatim from
 * UnifiedStockerDashboard.jsx. The rest of the dashboard still renders with
 * whatever data did load successfully; this is a small notice, not a
 * full-page error state.
 */
const DashboardLoadErrorBanner = ({ errors, onRetry }) => {
  const { t } = useTranslation();

  if (!errors?.length) return null;

  return (
    <div className="mb-4 flex items-center justify-between gap-3 px-4 py-2.5 rounded-xl bg-amber-50 dark:bg-amber-900/10 border border-amber-200 dark:border-amber-500/20 text-sm text-amber-800 dark:text-amber-300">
      <span>
        {t("dashboard.unifiedDashboard.loadErrorPrefix", { items: errors.map((e) => e.label).join(", ") })}
      </span>
      <button
        type="button"
        onClick={onRetry}
        className="flex-shrink-0 px-3 py-1 rounded-lg bg-amber-600 hover:bg-amber-500 text-white text-xs font-semibold transition-colors"
      >
        {t("dashboard.unifiedDashboard.retry")}
      </button>
    </div>
  );
};

export default DashboardLoadErrorBanner;
